import React from 'react';
import clients_icon from './assets/clients-icon.svg';
import check_icon from './assets/check-icon.svg';
import back_icon from './assets/back.svg'; 
import './SideBar.css';
import logo from './assets/logo.svg';
import { Link, useLocation } from 'react-router-dom';

export default function TopBar() {
    const active = {backgroundColor: '#6359E9'};
    const location = useLocation();
    const path = location.pathname;
    return (
        <div className="side-bar">
            <div className="side-bar--logo">
                <img src={logo} alt="logo" />
                <h1>Shopify APIs</h1>
            </div>
            <div className="side-bar--menu">
                <Link className="side-bar--menu-item" to="" style={path.includes('form') ? active : {}}>
                    <img src={clients_icon} alt="clients-icon" />
                    <p>Shopify Domains</p>
                </Link>
                <Link className="side-bar--menu-item" to="check" style={path.includes('/check') ? active : {}}>
                    <img src={check_icon} alt="check-icon" />
                    <p>Check</p>
                </Link>
                <Link className="side-bar--menu-item back" to='/services'>
                    <img src={back_icon} alt="settings-icon" />
                    <p>Back</p>
                </Link>
            </div>
        </div>
    );
}